var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRubyAlt4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_327)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_28_327)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_28_327)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.198 106.906L101.44 183.519L12.2225 106.976L88.0296 132.699L189.198 106.906Z",
    fill: "#BE4234"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.192 133.936L101.232 183.589L59.5413 127.779L104.192 133.936V133.936Z",
    fill: "url(#paint0_linear_28_327)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.809 107.073L101.134 183.686L148.828 127.876L188.809 107.073V107.073Z",
    fill: "url(#paint1_linear_28_327)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.992 55.3768L188.754 107.156L133.458 77.7368L167.992 55.3768V55.3768Z",
    fill: "#BE4234"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.598 73.4566L104.331 134.074L69.6443 75.5967L135.598 73.4566V73.4566Z",
    fill: "#BE4234"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4236 79.4878L28.5931 117.954L34.4992 59.4903L72.4236 79.4878V79.4878Z",
    fill: "#BE4234"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.71 36.241L7.98414 67.2447L37.3759 58.7816L38.71 36.241Z",
    fill: "#BE4234"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.485 31.919L189.685 62.089L167.297 55.5714L156.485 31.919V31.919Z",
    fill: "#BE4234"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.374 30.9463L168.214 55.7104L133.903 77.4589L72.1456 79.7379L34.4158 60.074L38.5848 35.7824L71.812 20.6488C86.5426 20.0929 115.323 19.3564 116.115 19.0923C116.907 18.8283 143.575 27.0969 156.374 30.9463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.009 77.1284C131.931 76.9478 162.851 65.3718 162.781 48.9597C162.712 32.5475 134.015 21.1938 101.135 21.3328C68.2554 21.4718 37.0154 32.2835 37.0432 48.7651C37.071 65.2467 66.1153 77.2813 99.009 77.1284V77.1284Z",
    fill: "#C13F3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.74 107.142L133.403 77.4866L104.497 133.769C134.348 132.824 163.726 127.849 188.74 107.142Z",
    fill: "url(#paint2_linear_28_327)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9929 79.6962L104.372 133.949C77.9685 133.282 51.8842 130.294 28.3013 118.024L71.9929 79.6962Z",
    fill: "url(#paint3_linear_28_327)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5654 118.065C10.9859 109.241 -8.95596 91.3558 8.151 67.1337L34.3604 59.6294L28.5654 118.065Z",
    fill: "url(#paint4_linear_28_327)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.504 61.9083C210.683 84.3099 195.299 100.361 188.712 107.17L168.047 55.5713L189.504 61.9083Z",
    fill: "#AA3E35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0343 79.849C68.2127 95.8165 60.4861 127.946 60.3054 128.571C60.0414 129.558 38.2929 123.735 28.7041 117.759L72.0343 79.849Z",
    fill: "url(#paint5_radial_28_327)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.43 77.459L149.314 127.64C134.794 131.79 119.751 133.821 104.65 133.672L133.43 77.459Z",
    fill: "url(#paint6_radial_28_327)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.228 55.6131L199.593 82.1143C201.261 92.9538 195.507 99.8188 188.406 105.947C181.263 89.2434 167.005 55.8632 168.228 55.6131Z",
    fill: "url(#paint7_linear_28_327)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6105 59.5182L5.31602 98.3736C-0.562324 88.8543 0.0491356 78.2928 8.012 67.217L34.6105 59.5182Z",
    fill: "url(#paint8_linear_28_327)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_327",
    x1: 77.7878,
    y1: 168.9,
    x2: 87.7379,
    y2: 118.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B3F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A23E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A23E36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28_327",
    x1: -4011.09,
    y1: 5976.38,
    x2: -4372.47,
    y2: 5462.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B3F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A23E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A23E36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_28_327",
    x1: 141.366,
    y1: 124.944,
    x2: 160.905,
    y2: 92.5925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F3633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A73532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B13439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B13439"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_28_327",
    x1: 65.6281,
    y1: 138.369,
    x2: 68.0184,
    y2: 94.6492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#923C36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#AA3531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA3531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_28_327",
    x1: 19.2406,
    y1: 108.935,
    x2: 18.4485,
    y2: 85.1578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D3E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#AA3E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA3E37"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_28_327",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.8219 98.6514) rotate(135) scale(39.9546 39.9546)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#923934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923934"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_28_327",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(141.185 96.7477) rotate(135) scale(53.1222 53.1222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE3531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#953A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953A36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_28_327",
    x1: 196.744,
    y1: 99.0823,
    x2: 174.356,
    y2: 57.9617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#994939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#AA3A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B83936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B83936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_28_327",
    x1: 19.7131,
    y1: 65.6606,
    x2: 7.9842,
    y2: 95.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9392F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#A23A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#8D463A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D463A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_28_327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white",
    transform: "translate(-41 81.4214) rotate(-45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_28_327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157.224,
    height: 157.224,
    fill: "white",
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 100.829 -26.7671)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubyAlt4);
export default __webpack_public_path__ + "static/media/ruby-alt4.3e145ce28ed1a05ff8cda149bb26b500.svg";
export { ForwardRef as ReactComponent };